<template>
  <div>
    <div
      style="height: 50px"
      class="livehead"
      :style="{ 'background-color': $store.getters.setting.bgColor }"
    >
      <div><slot name="header" /></div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
